// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".step-title[data-v-ee8e0eee]{font-size:25px}", "",{"version":3,"sources":["webpack://./modules/frontend/themes/whocanfixmycar/assets/js/components/Partials/Steps.vue"],"names":[],"mappings":"AACI,6BACI,cAAR","sourcesContent":["\n    .step-title {\n        font-size: 25px;\n    }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
